<template>
  <b-card :title="$t('userSearch')">
    <b-form inline @reset="resetFilter">
      <b-input-group id="user-group"  class="mr-4">
        <label class="mr-2" > {{ $t('user') }}</label>
        <b-form-input id="user" type="text" v-model="filter.user" v-on:keyup="onKeyup"/>
      </b-input-group>

      <b-input-group id="organization-group" class="mr-4">
        <label class="mr-2"> {{ $t('school') }}</label>
        <b-form-input id="organization" type="text" v-model="filter.organization" v-on:keyup="onKeyup"/>
      </b-input-group>

      <b-input-group id="role-group" class="mr-4">
        <label class="mr-2"> {{ $t('role') }}</label>
        <b-form-select size="sm" id="role" v-model="filter.role" :options="roles">
          <template slot="first">
            <option :value="null">{{ $t('all')}}</option>
          </template>
        </b-form-select>
      </b-input-group>

      <b-col>
        <b-button type="reset">{{ $t('reset') }}</b-button>
      </b-col>
    </b-form>

  </b-card>

</template>
<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'QuickUserSearch',
    computed:{
      ...mapGetters('users', ['filter']),
      ...mapState('users', { filter: state => state.filter }),
      roles () {
        return [
          { value: 'TEACHER', text: this.$t('userPrimaryRoles.TEACHER') },
          { value: 'STUDENT', text: this.$t('userPrimaryRoles.STUDENT') }
        ]
      }
    },

    methods: {
      onKeyup(event) {
        if (event.which === 13) {
          this.userSearch()
        }
      },
      userSearch(){
        this.$store.dispatch('users/getUsers', this.filter)
          .then(() => {
            this.$router.push('/users')
          })
      },
      resetFilter () {
        this.$store.dispatch('users/resetFilter')
      }
    }
  }
</script>
